module.exports = __webpack_public_path__ + "img/search-small-sentosa.b5712334.svg";